import { config } from '@packages/shared/config';
import { joinUrls } from '@packages/shared/core/common/utils/url';
import { TECHNICAL_LINKS } from './technicalLinks';

export enum PagePath {
  HOME = '/',
  BLOGS = '/blog',
  BLOGS_PAGE = '/blog/page',
  BLOG_TAG = '/blog/tag',
  NEBULA_APP_MOBILE = '/nebula-app-mobile',
  ZODIAC_COMPATIBILITY = '/zodiac-compatibility',
  ZODIAC_SIGN = '/zodiac-sign',
  REVIEWS = '/reviews',
  CONTACT_US = '/contact-us',
  FAQ = '/faq',
  CAREERS = '/careers',
  PRESS = '/press',
  SUPPORT = '/support',
  TRUST_AND_SAFETY = '/trust-safety-center',
  SUPPORT_BOT = '/support-bot',
  DAILY_HOROSCOPE = '/horoscope/daily',
  SIGN_UP = '/signup',
  MEANING = '/meaning',
  ADVISORS = '/advisors',
  WRITERS = '/writer',
  CHARTS = '/charts',
  ADVISORS_PAGE = '/advisors/page',
  ABOUT_US = '/about-us',
  HOW_WE_PICK_ADVISORS = '/how-we-pick-advisors',
  HOW_WE_WRITE_CHECK_PUBLISH_OUR_CONTENT = '/how-we-write-check-publish-our-content',
  OUR_AUTHORS = '/our-authors',
  EXPERT = '/expert',

  // Guidance app routes
  POST_QUIZ = '/flow/lp/intro-offer-1',
  SIMPLE_REGISTRATION_LANDING = '/flow/lp/simple-registration',
  SIMPLE_REGISTRATION_FORGOT_PASSWORD = '/flow/lp/simple-registration/forgot-password',
  SIMPLE_REGISTRATION_FORGOT_PASSWORD_SUCCESS = '/flow/lp/simple-registration/forgot-password-success',
  SIMPLE_REGISTRATION_QUIZ = '/flow/lp/simple-registration/quiz',
  SIMPLE_REGISTRATION_QUIZ_PSYCHIC_READING = '/flow/lp/simple-registration/quiz/psychicReading',
  SIMPLE_SIMPLE_REGISTRATION_QUIZ = '/flow/lp/simple-simple-registration/quiz',
  SIMPLE_SIMPLE_REGISTRATION_QUIZ_GENDER = '/flow/lp/simple-simple-registration/quiz/gender',
  EXPERTS_CATALOGUE = '/flow/lp/experts-catalogue',
  EXPERTS_CATALOGUE_PSYCHICS_CATALOGUE = '/flow/lp/experts-catalogue/psychics/catalogue',
  EXPERTS_CATALOGUE_PSYCHICS = '/flow/lp/experts-catalogue/psychics',
  EXPERTS_CATALOGUE_PSYCHICS_QUIZ = '/flow/lp/experts-catalogue/psychics/signUp',
  EXPERTS_CATALOGUE_PSYCHICS_CHAT = '/flow/lp/experts-catalogue/psychics/chat',
  SIMPLE_REGISTRATION_CHEATING_LANDING = '/funnel/simple-registration-cheating',
  SIMPLE_REGISTRATION_CHEATING_FORGOT_PASSWORD = '/funnel/simple-registration-cheating/forgot-password',
  SIMPLE_REGISTRATION_CHEATING_FORGOT_PASSWORD_SUCCESS = '/funnel/simple-registration-cheating/forgot-password-success',
  SIMPLE_REGISTRATION_CHEATING_QUIZ = '/funnel/simple-registration-cheating/quiz',
  SIMPLE_REGISTRATION_CHEATING_QUIZ_PSYCHIC_READING = '/funnel/simple-registration-cheating/quiz/psychicReading',
}

export const guidanceRoutes = {
  simpleRegistrationLanding: joinUrls(config.appOrigin.guidance, PagePath.SIMPLE_REGISTRATION_LANDING),
  simpleSimpleRegistrationQuizGender: joinUrls(
    config.appOrigin.guidance,
    PagePath.SIMPLE_SIMPLE_REGISTRATION_QUIZ_GENDER,
  ),
  expertsCatalogue: joinUrls(config.appOrigin.guidance, PagePath.EXPERTS_CATALOGUE),
  expertsCataloguePsychicsCatalogue: joinUrls(config.appOrigin.guidance, PagePath.EXPERTS_CATALOGUE_PSYCHICS_CATALOGUE),
  expertsCataloguePsychicsQuiz: joinUrls(config.appOrigin.guidance, PagePath.EXPERTS_CATALOGUE_PSYCHICS_QUIZ),
  expertsCataloguePsychicsChat: joinUrls(config.appOrigin.guidance, PagePath.EXPERTS_CATALOGUE_PSYCHICS_CHAT),
};

const appPath = '/app';

export const mainAppRoutes = {
  // App legal routes
  privacy: joinUrls(config.appOrigin.mainApp, appPath, 'privacy'),
  terms: joinUrls(config.appOrigin.mainApp, appPath, 'terms'),
  cookiePolicy: joinUrls(config.appOrigin.mainApp, appPath, 'cookie-policy'),
  moneyBackPolicy: joinUrls(config.appOrigin.mainApp, appPath, 'money-back-policy'),
  impressum: joinUrls(config.appOrigin.mainApp, appPath, 'impressum'),
  fullDisclaimer: joinUrls(config.appOrigin.mainApp, appPath, 'full-disclaimer'),
  legalCenter: joinUrls(config.appOrigin.mainApp, appPath, 'legal-center'),
  // Other app routes
  FAQ: joinUrls(config.appOrigin.mainApp, appPath, 'faq'),
  support: TECHNICAL_LINKS.nebula.support,
  supportApp: joinUrls(config.appOrigin.mainApp, appPath, 'support'),
  login: joinUrls(config.appOrigin.mainApp, appPath, 'login'),
  experts: joinUrls(config.appOrigin.mainApp, appPath, 'experts'),
  signupCredits: joinUrls(config.appOrigin.mainApp, appPath, 'signup/credits'),
  signupFreeTrial: joinUrls(config.appOrigin.mainApp, appPath, 'signup/trial-info'),
  expertChat: joinUrls(config.appOrigin.mainApp, appPath, 'chat/'),
  signUp: joinUrls(config.appOrigin.mainApp, appPath, 'signup'),
  commands: joinUrls(config.appOrigin.mainApp, appPath, 'commands/'),
};

export const loaderEnabledRoutes = ['/flow/lp'];
